import {
  TaskListItemFragment,
  LegalMatterCalendarEventFragment,
  Document,
  LegalMatter,
} from '@generatedTypes/graphql'
import {
  legalMatterEvents,
  taskEvents,
  calendarEvents,
  documentEvents,
} from '@interfaces/Notification'
import { NotificationType } from '@/interfaces/Notification'

interface TaskEventType extends TaskListItemFragment {
  legal_matter_ref_encoded: string
}

interface CalendarEventType extends LegalMatterCalendarEventFragment {
  legal_matter_ref_encoded: string
}

interface DocumentEventType extends Document {
  legal_matter_ref_encoded: string
}

interface LegalMatterEventType extends LegalMatter {
  key_encoded: string
  assigned_lawyer_ref_encoded: string
}

interface GeneralEventType {
  acl: any
  created_at: Date
  id: string
  identity: any
  identity_encoded: string
  legal_matter?: LegalMatterEventType
  task?: TaskEventType
  calendar_event?: CalendarEventType
  document?: DocumentEventType
  firm: any
}

export interface NotificationEventBase {
  type: NotificationType
  acl: any
  created_timestamp: string
  event: GeneralEventType
}

export class NotificationEvent implements NotificationEventBase {
  type: NotificationType
  acl: any
  created_timestamp: string
  event: GeneralEventType
  legal_matter_key: string

  constructor(data: NotificationEventBase) {
    this.type = data.type
    this.acl = data.acl
    this.created_timestamp = data.created_timestamp
    this.event = data.event
    this.legal_matter_key = getEventLocationKey(data.type, data.event) ?? ''
  }
}

export const getEventLocationKey = (
  eventType: NotificationType,
  data: GeneralEventType,
): string | undefined => {
  if (legalMatterEvents.includes(eventType))
    return data?.legal_matter?.key_encoded
  if (taskEvents.includes(eventType))
    return data?.task?.legal_matter_ref_encoded
  if (calendarEvents.includes(eventType))
    return data?.calendar_event?.legal_matter_ref_encoded
  if (documentEvents.includes(eventType))
    return data?.document?.legal_matter_ref_encoded
  return undefined
}
